import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "hero",
  "aria-label": "Hero introduction"
}
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = { class: "hero-text" }
const _hoisted_5 = { class: "cta-buttons" }
const _hoisted_6 = {
  class: "cta-section",
  "aria-label": "Call to action"
}
const _hoisted_7 = { class: "section-content" }
const _hoisted_8 = { class: "cta-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddToSlackButton = _resolveComponent("AddToSlackButton")!
  const _component_PublicLayout = _resolveComponent("PublicLayout")!

  return (_openBlock(), _createBlock(_component_PublicLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("h1", null, [
                _createElementVNode("span", { class: "main-text" }, [
                  _createTextVNode("Work is great —"),
                  _createElementVNode("br"),
                  _createTextVNode("when you"),
                  _createElementVNode("br"),
                  _createElementVNode("span", { class: "highlight" }, "appreciate")
                ]),
                _createElementVNode("span", { class: "playful" }, "(Prec8!)")
              ], -1)),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "hero-subtitle" }, "Transform your team culture with simple recognition that brings teams together", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_AddToSlackButton),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args))),
                  class: "sign-in-button",
                  "aria-label": "Sign in to your account"
                }, "Sign In")
              ])
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", {
              class: "hero-image",
              "aria-hidden": "true"
            }, [
              _createElementVNode("div", { class: "floating-card card-1" }, [
                _createElementVNode("span", {
                  class: "emoji",
                  role: "img",
                  "aria-label": "celebration"
                }, "🎉"),
                _createElementVNode("p", null, [
                  _createTextVNode("Great job on the release! "),
                  _createElementVNode("span", { class: "mention" }, "@harry")
                ])
              ]),
              _createElementVNode("div", { class: "floating-card card-2" }, [
                _createElementVNode("span", {
                  class: "emoji",
                  role: "img",
                  "aria-label": "star"
                }, "⭐️"),
                _createElementVNode("p", null, [
                  _createElementVNode("span", { class: "mention" }, "@jean"),
                  _createTextVNode(" thanks for helping out!")
                ])
              ])
            ], -1))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", {
            class: "hero-shape",
            "aria-hidden": "true"
          }, null, -1))
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("section", {
          class: "features",
          "aria-label": "Key features"
        }, [
          _createElementVNode("div", { class: "section-content" }, [
            _createElementVNode("h2", null, [
              _createTextVNode("Recognition Made "),
              _createElementVNode("span", { class: "highlight" }, "Simple")
            ]),
            _createElementVNode("div", { class: "features-grid" }, [
              _createElementVNode("article", { class: "feature-card" }, [
                _createElementVNode("div", {
                  class: "feature-icon",
                  role: "img",
                  "aria-label": "target"
                }, "🎯"),
                _createElementVNode("h3", null, "Give Points"),
                _createElementVNode("p", null, "Recognize teammates with a simple Slack message and emoji reactions")
              ]),
              _createElementVNode("article", { class: "feature-card" }, [
                _createElementVNode("div", {
                  class: "feature-icon",
                  role: "img",
                  "aria-label": "trophy"
                }, "🏆"),
                _createElementVNode("h3", null, "Track Progress"),
                _createElementVNode("p", null, "Watch your team's appreciation grow with real-time analytics and leaderboards")
              ]),
              _createElementVNode("article", { class: "feature-card" }, [
                _createElementVNode("div", {
                  class: "feature-icon",
                  role: "img",
                  "aria-label": "flexed biceps"
                }, "💪"),
                _createElementVNode("h3", null, "Build Culture"),
                _createElementVNode("p", null, "Create a positive team environment that celebrates achievements and collaboration")
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "features-shape",
            "aria-hidden": "true"
          })
        ], -1)),
        _createElementVNode("section", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("h2", null, [
              _createTextVNode("Ready to Transform Your "),
              _createElementVNode("span", { class: "highlight" }, "Team Culture"),
              _createTextVNode("?")
            ], -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", null, "Join thousands of teams using Prec8 to build stronger, more appreciative workplaces.", -1)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_AddToSlackButton),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args))),
                class: "sign-in-button secondary"
              }, "Sign In")
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}